import { combineReducers } from 'redux';
import settings from './settings';

const SettingsReducer = combineReducers({
  settings,
});

export default SettingsReducer;
